const BleuForm = () => {
  return (
    <svg
      width="1554"
      height="1601"
      viewBox="0 0 1554 1601"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.7902 775.218C-255.473 878.221 1085.85 1964.75 1519.84 1474.24C1685.93 1456.95 1183 355.557 1079.58 184.923C927.842 -197.606 1044.17 122.39 494.201 195.122C-34.0102 264.975 343.053 672.214 43.7902 775.218Z"
        fill="#D2E5E0"
      />
    </svg>
  );
};

export default BleuForm;
